import React from 'react';
import { useOnboardingStore } from '@/store/onboardingStore';
import { Topbar } from './Topbar';
import { Sidebar } from './Sidebar';




export const AuthenticatedLayout = ({ children }: { children: React.ReactNode }) => {
    const hasPendingOnboarding = useOnboardingStore((state) => state.isOnboardingPending());

    return (
        <div className="h-screen overflow-hidden bg-[#eff1f7] flex flex-col">
            <Topbar />
            <div className='flex w-full flex-1 min-h-0'>
                {!hasPendingOnboarding && <Sidebar />}
                <div className="px-4 pt-5 pb-4 overflow-y-auto scrollbar-hide w-full flex-1 min-h-0">
                    {children}
                </div>
            </div>
        </div>
    );
};
